"use client";

import Cookies from "js-cookie";
import type { SubscriptionLevel } from "lib/types";
import type { StoreState } from "./index";
import { UnauthorizedZephrUserProfile } from "./const";

export type UserProfile = Window["Sifted"]["user"] & {
  trackingId: string;
};

type UseUserDataProps = StoreState["user"] & {
  /**
   * All registered users
   */
  isAuthorisedUser: boolean;
  /**
   * Registered pro users
   */
  isProUser: boolean;
  /**
   * Non pro registered user
   */
  isNonProUser: boolean;

  isAcademicUser: boolean;

  userProfile: UserProfile;
};

const getSubscriptionLevel = (userProfile: UserProfile): SubscriptionLevel => {
  if (userProfile.is_pro) {
    return "pro";
  }

  if (userProfile.is_logged_in) {
    return "registered";
  }

  return "unregistered";
};

export const getUserId = () => Cookies.get("blaize_tracking_id") || "";

const userProfile = ((): UserProfile => {
  if (typeof window === "undefined" || !window.Sifted?.user) {
    return UnauthorizedZephrUserProfile;
  }

  return {
    ...window.Sifted.user,
    trackingId: getUserId(),
  };
})();

export const useUserData = (): UseUserDataProps => ({
  userProfile,
  userId: userProfile.trackingId,
  isAuthorisedUser: userProfile.is_logged_in,
  isProUser: userProfile.is_pro,
  isNonProUser: !userProfile.is_pro,
  isAcademicUser: userProfile.details.is_academic_user,
  readerSubscriptionLevel: getSubscriptionLevel(userProfile),
  hasMissingInfo:
    !userProfile.details.form_company_size ||
    !userProfile.details.form_department ||
    !userProfile.details.form_job_title,
  showVerification: () => Promise.resolve(false),
});
